<template>
  <div>
    <apexchart
      v-if="shiftSeries.some((v) => v > 0)"
      type="donut"
      height="460"
      :options="shiftsOpts"
      :series="shiftSeries"
    />
    <empty-state
      v-else
      icon="mdi-chart-donut"
      :title="$t('no_data')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "GroupMealsShiftsChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    shiftSeries() {
      const totals = [0, 0, 0, 0];
      for (const item of this.orders) {
        if (item.shift_1 !== undefined) {
          totals[0] += Number(item.shift_1 || 0);
          totals[1] += Number(item.shift_2 || 0);
          totals[2] += Number(item.shift_3 || 0);
          totals[3] += Number(item.shift_4 || 0);
        } else {
          const s = (item.shift || 1) - 1;
          if (s >= 0 && s < 4) totals[s] += Number(item.quantity || 0);
        }
      }
      return totals;
    },
    shiftsOpts() {
      return {
        chart: { type: "donut", fontFamily: "Roboto, sans-serif" },
        labels: this.shiftLabels,
        colors: SHIFT_COLORS,
        legend: { position: "bottom" },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
          dropShadow: { enabled: false },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: this.$t("total"),
                  formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0),
                },
              },
            },
          },
        },
        tooltip: { y: { formatter: (val) => `${val} ${this.$t("meal_meal")}` } },
      };
    },
  },
};
</script>
